package us.laantech.common.dto.company

import io.ktor.http.*
import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.descriptors.SerialKind
import us.laantech.common.dto.EmployeeDTO
import us.laantech.common.dto.PosConfigDTO
import us.laantech.common.dto.UnitedStatesPostalAddress
import us.laantech.common.dto.UnitedStatesState
import us.laantech.common.util.generateUUIDv7
import kotlin.time.Clock

@Serializable
data class ParentCompany(

    val uuid: String? = generateUUIDv7(),

    // Account info
    val accountSub: String?,

    // Client contact info
    val contactInfo: ContactInfo?,

    // Company info
    val companyInfo: CompanyInfo?,

    // Payment Terminal transaction rate
    val cardTransactionRate5dp: Long?,

    // 5-digit precision stored as Long
    val taxRates: Set<TaxRate>? = emptySet(),

    // Subscriptions
    val productLicenses: List<InternalProductLicenseDTO> = listOf(),

    // Client Configs and settings
    val posConfigs: List<PosConfigDTO>? = listOf(),
//TODO    val backofficeConfigs: List<BackofficeConfigDTO>? = listOf(),

    // Managerial Employees, can login and access company data
    val managers: Set<EmployeeDTO>? = setOf(),

    // Standard Employees, can only clock in and clock out
    val employees: Set<EmployeeDTO>? = setOf(),

    ) {


    fun getCurrentTaxRate(usState: UnitedStatesState): Long {
        val now = Clock.System.now().toEpochMilliseconds()

        val taxRate = taxRates?.filter {
            (it.usState == usState) && // In this state and
                    (it.startAt ?: Long.MIN_VALUE) <= now // not in the future
        }?.maxByOrNull { it.startAt ?: Long.MIN_VALUE } // get the most recent one

        return  taxRate?.taxRates5dp ?: 0L
    }

    init {
        // TODO validation
    }

    /**
     * Usage
     * val fields = getFormFields(UserProfile.serializer())
     * [("name", STRING), ("age", INT), ("email", STRING), ("active", BOOLEAN)]
     */
    fun getFormFields(serializer: KSerializer<*>): List<Pair<String, SerialKind>> {
        val descriptor = serializer.descriptor
        return (0 until descriptor.elementsCount).map { i ->
            descriptor.getElementName(i) to descriptor.getElementDescriptor(i).kind
        }
    }

}


@Serializable
data class TaxRate(
    val taxRates5dp: Long?,
    val usState: UnitedStatesState?,
    val startAt: Long?,
)

@Serializable
data class ContactInfo(
    val postalAddress: UnitedStatesPostalAddress? = null,
    val phoneNumberPrimary: String? = null,
    val phoneNumberSecondary: String? = null,
    val website: Url? = null,
)

@Serializable
data class CompanyInfo(
    val companyName: String?,

//    @field:Schema(pattern = "^[A-Z0-9]{2,4}[-]?[A-Z0-9]{6,12}[-]?[A-Z0-9]{0,2}\$")
    val resaleCertNumber: String?,


//    @field:Schema(pattern = "^\\d{2}-?\\d{7}\$")
    val employerIdNumber: String?,

//    @field:Schema(pattern = "^(CONVENIENCE|GAS|MULTI_NATIONAL|OTHER)$")
    val companyType: String? = null,
)


@Serializable
data class InternalProductLicenseDTO(

    val uuid: String? = generateUUIDv7(),

    // What product is licensed?
    val productUUID: String,

    // When is the customer charged?
    val billingStartDate: Long?,

    // How is the customer charged?
    val priceCents: Long?,

    val billingCycle: BillingCycle?,

    // How is the license attached to the customer?
    val hardwareIdentifier: String? = null,

    // Status
    val enabled: Boolean? = false,
    val createdAt: Long? = null,
    val updatedAt: Long? = null,
    val expireDate: Long? = null,

    // Data products may have a data retention policy
    val dataRetentionPolicyDays: Long = -1L

)

enum class BillingCycle {
    NEVER,
    ONCE,
    MONTHLY,
    QUARTERLY,
    YEARLY
}

@Serializable
data class PricingPlan(
    val tierName: String?,
    val priceCents: Long?,
    val billingCycle: BillingCycle?,

    )